'use client';

import React, { useEffect, useState } from 'react';
import useUserStore from '@/lib/hooks/zustand-stores/use-user-store';
import BaseUserInitializer from '@/components/user/base-user-initializer';
import ChatListInitializer from '@/components/chat-list-initializer';
import NotificationInitializer from '@/components/notifications/notifications-initializer';
import { TeamInviteHandler } from '@/components/team/team-invite-handler'
import ExtendUserInitializer from '@/components/user/extend-user-initializer'
import { usePathname } from 'next/navigation';
import AppStoreInitializer from './app-store-initializer'
import { WebSocketProvider } from '@/app/web-socket-provider';


const AppInit: React.FC = () => {
  const userId = useUserStore((state) => state.user?._id);

  const cleanLocalStorageKeys = () => {
    const keysToClean = [
      `userCacheV2_${userId}`,
      'chat-storage',
    ];

    keysToClean.forEach(key => {
      if (localStorage.getItem(key)) {
        localStorage.removeItem(key);
      }
    });
  };

  useEffect(() => {
    if (userId) {
      // Clean localStorage keys first
      cleanLocalStorageKeys();
     }
  }, [userId]);


  return (
    <>
      {/* Priority 1: Always initialize the user first */}
      <BaseUserInitializer />

      {/* 
        Always render WebSocketProvider to maintain consistent hook execution,
        but the internal functionality only activates when userId exists.
        This helps prevent React hook ordering issues during rerenders.
      */}
      <WebSocketProvider>
        {/* Priority 3: Load secondary initializers only when user is authenticated */}
        {userId && (
          <>
            <AppStoreInitializer/>
            <TeamInviteHandler/>
            <ChatListInitializer />
            <NotificationInitializer />
            <ExtendUserInitializer/>
          </>
        )}
      </WebSocketProvider>
    </>
  );
};

export default AppInit;
